/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getByDocumentid } from '../fn/documents/get-by-documentid';
import { GetByDocumentid$Params } from '../fn/documents/get-by-documentid';

@Injectable({ providedIn: 'root' })
export class ApiDocumentsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDocumentsByDocumentid()` */
  static readonly GetDocumentsByDocumentidPath = '/Documents/{documentId}';

  /**
   * get-documents-by-documentid.
   *
   * Get document by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByDocumentid()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByDocumentid$Response(params: GetByDocumentid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getByDocumentid(this.http, this.rootUrl, params, context);
  }

  /**
   * get-documents-by-documentid.
   *
   * Get document by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByDocumentid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByDocumentid(params: GetByDocumentid$Params, context?: HttpContext): Observable<void> {
    return this.getByDocumentid$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
